import { createDecorator } from "vue-class-component";

export default createDecorator((options, key) => {
  // component options should be passed to the callback
  // and update for the options object affect the component
  options.computed = options.computed || {};
  (options.computed[key] as any).cache = false;
});
